var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 400 400",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.6,158.6c0-5.9,4.8-10.5,11.2-10.5c6.4,0,11.2,4.3,11.2,10.1c0,6.2-4.6,10.9-11.2,10.9 C194.4,169.1,189.6,164.5,189.6,158.6z M192,181.4h17.5v74.9H192V181.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295,309.2c-2.7,0-6.1-0.7-10.2-2.9c-0.3-0.1-26.4-13.3-43.3-6.2c-13.3,5.6-27.4,8.4-42,8.4 c-59.9,0-108.7-48.8-108.7-108.7c0-59.9,48.8-108.7,108.7-108.7S308.2,140,308.2,199.9c0,20.3-5.7,40.2-11.3,49.3 c-1.1,1.9-1.4,11.1,2,21.2l6.3,18.4c3.6,10.5,0,15.6-2.4,17.7C301.3,307.7,298.8,309.2,295,309.2z M253.2,286.1 c18.3,0,36.2,9.1,37.2,9.6c2.2,1.1,3.6,1.4,4.3,1.5c0-0.7-0.1-2.1-0.9-4.5l-6.3-18.4c-3.6-10.5-5-24.6-0.9-31.4 c3.7-6,9.6-22.9,9.6-42.9c0-53.3-43.4-96.7-96.7-96.7s-96.7,43.4-96.7,96.7c0,53.3,43.4,96.7,96.7,96.7c13,0,25.5-2.5,37.3-7.5 C242,286.9,247.6,286.1,253.2,286.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInfo);
export default __webpack_public_path__ + "static/media/notification_info.9f317923.svg";
export { ForwardRef as ReactComponent };